/* @flow */
import idx from 'idx';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AdminUpgradeFeatures from 'admin/components/AdminUpgradeFeatures';
import AdminUpgradeFooter from 'admin/components/AdminUpgradeFooter';
import AdminUpgradeForms from 'admin/components/AdminUpgradeForms';
import AdminUpgradeHelp from 'admin/components/AdminUpgradeHelp';
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader';
import AdminUpgradeStatsContainer from 'admin/components/AdminUpgradeStats';
import AdminUpgradeTitle from 'admin/components/AdminUpgradeTitle';
import {
  PAGE_NUMBER,
  saveLocalQuoteField,
  saveQuote,
  saveQuoteToFields,
} from 'admin/reducers/adminUpgradePage';
import type { State as ReduxState } from 'admin/reducers/adminUpgradePage';
import { withRouter } from 'app/context/Router';
import ProgressLabel from 'components/ProgressLabel';
import Row from 'components/Row';

import './styles/AdminUpgradePageView.scss';

const UTM = {
  utm_source: 'utmSource',
  utm_medium: 'utmMedium',
  utm_content: 'utmContent',
  utm_campaign: 'utmCampaign',
};

type Props = {
  _saveLocalQuoteField: Function,
  _saveQuote: Function,
  _saveQuoteToFields: Function,
  organizationUuid: ?string,
  quote: ?Object,
  reduxState: ReduxState,
  referredFromSales: ?boolean,
  router: *,
};

type State = {
  organizationUuid: ?string,
};

class AdminUpgradePageView extends React.Component<Props, State> {
  state: State = {
    organizationUuid: null,
  };

  componentDidMount() {
    if (this.props.quote) {
      this.props._saveQuoteToFields(this.props.quote);
    }

    if (this.props.organizationUuid) {
      this.props._saveLocalQuoteField('organizationUuid', this.props.organizationUuid);
    }

    for (const key in UTM) {
      if (UTM.hasOwnProperty(key)) {
        if (this.props.router.location.query[key]) {
          this.props._saveLocalQuoteField(UTM[key], this.props.router.location.query[key]);
        }
      }
    }
  }

  handleNoStats = () => {
    this.setState({ organizationUuid: null });
  };

  handleSelectSchool = (organizationUuid: string) => {
    this.setState({ organizationUuid });
  };

  render() {
    const { reduxState, organizationUuid: propsOrganizationUuid, referredFromSales } = this.props;
    const { organizationUuid: stateOrganizationUuid } = this.state;

    const quoteStudentCount = idx(reduxState.quote, _ => _.studentCount);
    const quoteUuid = idx(reduxState.quote, _ => _.uuid);

    const organizationUuid = propsOrganizationUuid || stateOrganizationUuid;

    const sidebar = organizationUuid ? (
      <AdminUpgradeStatsContainer
        organizationUuid={organizationUuid}
        onNoStats={this.handleNoStats}
      />
    ) : (
      <AdminUpgradeFeatures />
    );

    return (
      <div className="AdminUpgradePageView">
        <AdminUpgradePageHeader
          title="The Remind plan for schools and districts"
          quoteUuid={quoteUuid}
        />
        <div className="AdminUpgradePageView-content" data-test="form">
          <ProgressLabel currentStep={reduxState.pageIndex + 1} steps={PAGE_NUMBER} />
          <div className="AdminUpgradePageView-content-body">
            <div className="AdminUpgradePageView-content-body-forms">
              <Row>
                <AdminUpgradeTitle quoteStudentCount={quoteStudentCount} />
              </Row>
              <AdminUpgradeForms
                organizationUuid={propsOrganizationUuid}
                onSelectSchool={this.handleSelectSchool}
              />
            </div>
            <div className="AdminUpgradePageView-content-body--desktop-side">
              <Row size="xxxlarge">{sidebar}</Row>
            </div>
          </div>
        </div>
        <div className="AdminUpgradePageView-footer">
          <AdminUpgradeFooter
            organizationUuid={organizationUuid}
            referredFromSales={referredFromSales}
          />
        </div>
        <div className="AdminUpgradePageView--mobile-bottom">
          <Row size="medium">
            <AdminUpgradeHelp quoteUuid={quoteUuid} full />
          </Row>
          <div className="AdminUpgradePageView-info-container">{sidebar}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    reduxState: state.adminUpgradePage,
  };
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowIssue - flow expects organizationUuid and quote here
  return bindActionCreators(
    {
      _saveQuote: saveQuote,
      _saveQuoteToFields: saveQuoteToFields,
      _saveLocalQuoteField: saveLocalQuoteField,
    },
    dispatch
  );
}

export { AdminUpgradePageView };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminUpgradePageView));
